// Mismos valores que acepta la API (shared/dto/paginacion.dto.ts)
export const LIMITES = [10, 25, 50, 100];
export const LIMITE_INICIAL = 25;
